import { useQuery } from "@tanstack/react-query";
import { queryKeys, type QueryOptions } from "@/lib/react-query";
import { apiListBoards } from "../services/curriculumService";
import type { Board } from "../types/curriculum.types";

const DEFAULT_OPTIONS = {
  staleTime: 1000 * 60 * 10,
  gcTime: 1000 * 60 * 30,
  refetchOnWindowFocus: false,
} as const;

export function useBoards(
  options?: QueryOptions<Board[]>,
  params?: { instituteId?: string },
) {
  const instituteId = params?.instituteId?.trim() || undefined;
  return useQuery({
    queryKey: queryKeys.boards.list(instituteId),
    queryFn: async () => await apiListBoards(instituteId ? { instituteId } : undefined),
    ...DEFAULT_OPTIONS,
    ...options,
  });
}
